import { User } from '@smarty-nx/data'

export const fullName = (user: Partial<User> | null): string => {
  if (!user) {
    return ''
  }

  return user.nickname ? user.nickname : `${user.first_name} ${user.last_name}`
}
